import React from 'react'
import { useLocation } from 'react-router-dom'

export function useTrackPageView(trackOnMount = true) {
  const location = useLocation()
  const shouldTrackPageViewRef = React.useRef(trackOnMount)

  React.useEffect(() => {
    if (shouldTrackPageViewRef.current) {
      window.gtag('event', 'page_view', {
        page_path: `${location.pathname}${location.search}`,
      })
    }
    shouldTrackPageViewRef.current = true
  }, [location.pathname, location.search])
}
